import React, { Component } from 'react';
import Link from '../elements/Link';
import {getPagesContent} from '../../data/selectors/config.selectors';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { List } from 'immutable';

class LinksPage extends Component {
    render() {
        const content = this.props.content.get(this.props.location.pathname, new List())
        return (
            <div className='nhp-links'>
                {content.map((c, i) =>
                    <Link key={i} data={c.toJS()}/>
                )}
            </div>
        )
    }
}

const mapStateToProps = state => ({
  content: getPagesContent(state),
})

const mapDispatchToProps = dispatch => ({
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LinksPage))